import helpers from '../../helpers';

class Screen {
	/**
	* @param {number || string} id - number {0..4}, 'default', 'promo'
	*/
	constructor(id) {
		this.id = id;
		if (id === 'default') {
			this.$leftBlock = $('.text-block-default');
			this.$collage = $('.collage-default');
			this.$bg = $('.screen-bg__default');
		} else if (id === 'promo') {
			this.$leftBlock = $('.text-block-promo');
			this.$collage = $('.collage-promo');
			this.$bg = this.$collage.find('.collage-bg');
		} else if (typeof id === 'number') {
			this.$leftBlock = $('.text-blocks .text-blocks__item').eq(id);
			this.$collage = $('.collages-box .cards-collage').eq(id);
			this.$bg = $('.screen-bg__item').eq(id + 1);
		} else {
			console.log('Id is invalid');
		}

		this.name = this.$leftBlock.find('.home__title').text();
	}

	getId() {
		if (typeof this.id === 'number') {
			return this.id;
		}

		return false;
	}

	fadeIn() {
		this.$leftBlock.removeClass('--fade-out');
		this.$collage.removeClass('--fade-out');
		this.$bg.removeClass('--fade-out');
		this.$leftBlock.css('display', 'block');
		this.$collage.css('display', 'block');
		// this.$bg.addClass('is-show');

		setTimeout(() => {
			this.$leftBlock.addClass('--fade-in');
			this.$collage.addClass('--fade-in');
			this.$bg.addClass('--fade-in');
		}, 100);

		setTimeout(() => {
			this.$leftBlock.addClass('is-current');
			this.$collage.addClass('is-current');
			this.$bg.addClass('is-current');

			if (typeof this.id === 'number') {
				helpers.$document.trigger('show-card', [this.name]);
			}
			if (this.id === 'promo') {
				helpers.$document.trigger('action-finish');
			}
		}, 4600);
	}

	fadeOut() {
		return new Promise((resolve) => {
			this.$leftBlock.removeClass('--fade-in');
			this.$collage.removeClass('--fade-in');
			this.$bg.removeClass('--fade-in');
			this.$leftBlock.addClass('--fade-out');
			this.$collage.addClass('--fade-out');
			this.$bg.addClass('--fade-out');

			setTimeout(() => {
				this.$leftBlock.css('display', 'none');
				this.$collage.css('display', 'none');
				this.$leftBlock.removeClass('is-current');
				this.$collage.removeClass('is-current');
				this.$bg.removeClass('is-current');
				// this.$bg.removeClass('--fade-out');
				this.$leftBlock.find('.js-name-open').removeClass('is-open');
				// window.scrollTo(0, 0);
				if (helpers.isMobile()) {
					window.scrollTo({
						top: 0,
						behavior: 'instant',
					});
				}
				resolve();
			}, 1200);
		});
	}
}

export default Screen;
